<template>
  <el-dialog
      :visible="cardVisible"
      width="700px"
      :before-close="closeCardBinding">
    <div class="cardBinding">
      <h2>绑定会员卡</h2>
      <div class="input-container">
        <el-input placeholder="请输入会员卡号" v-model="cardNum"  style="width: 400px"></el-input>
      </div>
      <div class="input-container">
        <el-input placeholder="请输入会员卡密码" v-model="cardPassWord" style="width: 400px"></el-input>
      </div>
      <div class="button-container">
        <el-button @click="bindingCard">绑定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {setVip} from "@/api/apis";
import {message} from "ant-design-vue";

export default {
  inject: ["reload"],
  name: "cardbinding",
  data() {
    return {
      cardVisible: true,
      cardNum: '',
      cardPassWord: '',
    };
  },
  methods:{
    bindingCard() {
      if (this.cardNum === '' || this.cardPassWord === '') {
        this.$message.error('请输入卡号和密码');
      }
      let json = {
        gkUserId: this.$store.state.userinfo.id,
        cardNum: this.cardNum,
        cardPassWord: this.cardPassWord
      };
      setVip(json).then((res)=> {
        if (res.success) {
          this.$message.success(res.message);
          this.cardVisible = false;
          location.reload();
        } else {
          this.$message.error(res.message);
        }
      })
    },
    closeCardBinding() {
      this.$store.commit("setBindingCardState", false);
    },
  }
}

</script>

<style scoped lang="less">
.cardBinding {
  text-align: center;
  margin: 0 auto;
  width: 600px; /* 与对话框宽度保持一致 */
}

.cardBinding h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

.cardBinding .input-container {
  margin-bottom: 10px;
}

.cardBinding .button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.cardBinding .el-button {
  width: 400px;
  background-color: purple;
  color: white;
}
</style>